/* ============================================================
   OBEE EXTRACTS — Anmeldung Endkunden + Händler

   Beide Formulare senden an Brevo. Dort läuft das Double Opt-in:
   Brevo schickt die Bestätigungsmail, prüft den Klick und
   protokolliert die Einwilligung mit Zeitstempel.

   Warum der Umweg über ein unsichtbares Fenster (iframe):
   Ein Formular auf officialobee.com, das an sibforms.com sendet,
   ist ein fremder Ursprung. Ein normales Absenden würde die Seite
   verlassen, und ein Absenden per fetch scheitert an den
   Sicherheitsregeln des Browsers. Mit target="…" landet Brevos
   Antwort in einem versteckten Fenster, die Seite bleibt stehen,
   und wir zeigen unsere eigene Meldung.

   Die Kehrseite: Wir sehen Brevos Antwort nicht. Deshalb wird
   vorher im Browser geprüft, was sich prüfen lässt — Pflichtfelder,
   E-Mail-Form, Einwilligung. Danach heisst es „schau in dein
   Postfach", denn genau das passiert.

   Kein API-Schlüssel im Spiel. Die Formularadresse ist öffentlich
   und darf es sein; sie kann nur Kontakte anlegen, nicht lesen.
   ============================================================ */
(function () {
  'use strict';
  var root = document.getElementById('join'); if (!root) return;

  /* Händlerbereich auf- und zuklappen */
  var toggle = root.querySelector('.trade .toggle');
  var panel  = root.querySelector('.trade-form');
  if (toggle && panel) {
    toggle.addEventListener('click', function () {
      var open = panel.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var f = panel.querySelector('input'); if (f) f.focus(); }
    });
  }

  /* Ein gemeinsames unsichtbares Fenster für beide Formulare */
  var sink = null;
  function target() {
    if (sink) return sink.name;
    sink = document.createElement('iframe');
    sink.name = 'obee-sink';
    sink.setAttribute('aria-hidden', 'true');
    sink.setAttribute('tabindex', '-1');
    sink.style.cssText = 'position:absolute;width:0;height:0;border:0;left:-9999px';
    document.body.appendChild(sink);
    return sink.name;
  }

  function wire(form, done) {
    if (!form || !form.getAttribute('action')) return;
    var msg = form.querySelector('.join-msg');
    var btn = form.querySelector('button[type=submit]');
    var sent = false;

    form.setAttribute('target', target());

    function say(kind, text) {
      if (!msg) return;
      msg.className = 'join-msg ' + kind;
      msg.textContent = text;
    }

    form.addEventListener('submit', function (ev) {
      if (sent) { ev.preventDefault(); return; }

      var mail = form.querySelector('input[type=email]');
      var ok   = form.querySelector('input[type=checkbox]');

      /* Pflichtfelder, die Brevo verlangt */
      var missing = null;
      Array.prototype.forEach.call(form.querySelectorAll('[required]'), function (el) {
        if (missing) return;
        if (el.type === 'checkbox') { if (!el.checked) missing = el; }
        else if (!el.value.trim()) missing = el;
      });

      function fail(el, text) {
        ev.preventDefault();
        say('err', text);
        if (el && el.focus) el.focus();
      }

      if (missing && missing.type !== 'checkbox') {
        return fail(missing, 'Please fill in ' +
          (missing.getAttribute('placeholder') || 'all fields').toLowerCase());
      }
      if (!mail || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(mail.value.trim())) {
        return fail(mail, 'Enter a valid email address');
      }
      if (ok && !ok.checked) return fail(ok, 'Please confirm your age and consent');

      /* Ab hier geht es raus. Wir sehen die Antwort nicht, aber wir
         merken am Laden des unsichtbaren Fensters, dass sie da ist. */
      sent = true;
      say('', 'Sending…');
      if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }

      var onLoad = function () {
        sink.removeEventListener('load', onLoad);
        say('ok', done);
        if (btn) btn.textContent = 'Check your inbox';
        var row = form.querySelector('.join-row, .trade-grid');
        if (row) row.style.opacity = '.35';
      };
      sink.addEventListener('load', onLoad);

      /* Falls die Antwort ausbleibt, trotzdem nicht ewig „Sending…" */
      setTimeout(function () {
        if (btn && btn.textContent === 'Sending…') onLoad();
      }, 6000);
    });
  }

  wire(document.getElementById('joinForm'),
       'Almost there — click the link in the email we just sent you.');
  wire(document.getElementById('tradeForm'),
       'Request received. Confirm the email we just sent, then we will verify your details.');
})();

/* ============================================================
   OBEE EXTRACTS — aktive Navigation nach Scrollposition
   ============================================================ */
(function () {
  'use strict';
  var links = document.querySelectorAll('.hdr nav a[href^="#"]');
  if (!links.length) return;

  var map = [];
  links.forEach(function (a) {
    var el = document.querySelector(a.getAttribute('href'));
    if (el) map.push({ a: a, el: el });
  });
  if (!map.length) return;

  function onScroll() {
    var y = window.scrollY + window.innerHeight * 0.35;
    var best = null;
    map.forEach(function (m) {
      var top = m.el.getBoundingClientRect().top + window.scrollY;
      if (top <= y) best = m;
    });
    map.forEach(function (m) { m.a.classList.toggle('active', m === best); });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();
})();

/* ============================================================
   OBEE EXTRACTS — Danke-Ebene nach der Bestätigung
   Brevo schickt den Besucher auf /?confirmed=1 (B2C) oder
   /?confirmed=trade. Danach wird das Anhängsel aus der Adresse
   entfernt, damit ein Neuladen nicht wieder danke sagt.
   ============================================================ */
(function () {
  'use strict';
  var box = document.getElementById('thanks'); if (!box) return;
  var m = /[?&]confirmed=([a-z0-9]+)/i.exec(window.location.search);
  if (!m) return;

  var TEXTS = {
    '1': ['You are on the list',
          'Your email is confirmed. We write when the store opens — not before.'],
    'trade': ['Request confirmed',
              'We check your VAT ID and come back to you. Trade terms differ from the consumer terms.'],
    'giveaway': ['You are in the draw',
                 'Your entry is confirmed. We draw after the fair and notify the winner by email.']
  };
  var t = TEXTS[m[1].toLowerCase()] || TEXTS['1'];
  var h = box.querySelector('[data-thanks-title]');
  var p = box.querySelector('[data-thanks-text]');
  if (h) h.textContent = t[0];
  if (p) p.textContent = t[1];

  box.hidden = false;
  requestAnimationFrame(function () { box.classList.add('on'); });
  document.body.classList.add('gate-open');

  function close() {
    box.classList.remove('on');
    document.body.classList.remove('gate-open');
    setTimeout(function () { box.hidden = true; }, 600);
    if (window.history && history.replaceState) {
      history.replaceState({}, '', window.location.pathname + window.location.hash);
    }
  }
  var b = box.querySelector('[data-thanks-close]');
  if (b) b.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();
